import { reportTypes, serializedTypes } from '@/reports/types';
import { SerializedUrlFraudReport } from '@/reports/types/serialized';
import isBlacklisted from '@/utils/isBlacklisted';

type UrlFraudReportSerializer = (
  rawReport: reportTypes.Report
) => serializedTypes.SerializedUrlFraudReport;
export class IPFraudReport {
  public data: serializedTypes.SerializedUrlFraudReport;

  constructor(
    rawData: reportTypes.Report,
    serializer: UrlFraudReportSerializer = SerializeUrlFraudReport
  ) {
    this.data = serializer(rawData);
  }
}
export function SerializeUrlFraudReport(
  rawUrlFraud: reportTypes.Report
): serializedTypes.SerializedUrlFraudReport {
  let is_Blacklisted = false;
  if (
    rawUrlFraud.meta?.report_info &&
    rawUrlFraud.meta.report_info.proxy_flags
  ) {
    is_Blacklisted = isBlacklisted(rawUrlFraud.meta.report_info.proxy_flags);
  }
  const data = rawUrlFraud?.supporting?.urls?.[0];
  const domain = data?.domain;

  const serializedUrlFraud: SerializedUrlFraudReport = {
    rawData: rawUrlFraud,
    isEmpty: !data,
    meta: rawUrlFraud.meta,
    alertMe: rawUrlFraud.meta?.alert_me || false,
    createdAt: rawUrlFraud.meta?.created_at || '',
    isBlacklisted: is_Blacklisted,
    url: rawUrlFraud.meta?.search_data?.url || '',
    reportUpgraded: rawUrlFraud.meta?.report_upgraded || false,
    id: rawUrlFraud.meta?.permalink || '',
    indices: data?.indices || [],
    domain: {
      mxRecords: data?.domain?.mx_records || [],
      ipRecords: data?.domain?.ip_records || [],
      nsRecords: data?.domain?.ns_records || [],
      age: domain?.age ?? undefined,
      isDmarcRecord: domain?.is_dmarc_record ?? undefined,
      isSpfRecord: domain?.is_spf_record ?? undefined,
      isRiskyTld: domain?.risky_tld ?? undefined,
      isDnsValid: domain?.is_dns_valid ?? undefined,
      isCommon: domain?.is_common ?? undefined,
      isParked: domain?.is_parked ?? undefined,
      domainRank: domain?.domain_rank ?? undefined,
      domain: domain?.domain || 'Unknown',
      rootDomain: domain?.root_domain || 'Unknown',
      trust: domain?.trust || 'Unknown',
      velocity: domain?.velocity || 'Unknown',
      suggestedDomain: domain?.suggested_domain || 'N/A',
    },
    isUnsafe: data?.is_unsafe,
    isSpam: data?.is_spam,
    isMalware: data?.is_malware,
    isPhishing: data?.is_phishing,
    isSuspicious: data?.is_suspicious,
    isAdult: data?.is_adult,
    isRedirected: data?.is_redirected,
    isShortLinkRedirect: data?.is_short_link_redirect,
    isHostedContent: data?.is_hosted_content,
    technologies: data?.technologies || [],
    display: data?.display,
    extended: data?.extended,
    pageTitle: data?.page_title || 'Unknown',
    ipAddress: data?.ip_address || 'Unknown',
    server: data?.server || 'Unknown',
    contentType: data?.content_type || 'Unknown',
    statusCode: data?.status_code ?? undefined,
    pageSize: data?.page_size ?? undefined,
    countryCode: data?.country_code || 'Unknown',
    languageCode: data?.language_code || 'Unknown',
    category: data?.category || 'Unknown',
    riskScore: data?.risk_score ?? undefined,
  };
  return serializedUrlFraud;
}
